import {
  LineCustomPropertyKeyType,
  QuoteCustomPropertyKeyType
} from 'graphql/models/extended';
import {
  type CustomProperty
} from 'graphql/models/generated';

export function getCustomProperty(
  customProperties: CustomProperty[] | undefined | null,
  key: LineCustomPropertyKeyType | QuoteCustomPropertyKeyType
): CustomProperty | undefined {
  if (
    Array.isArray(customProperties)
    && typeof key === 'string' && key.length > 0
  ) {
    const property = customProperties.find((prop) => prop.key === key);

    // this catches the null object as well
    if (property && typeof property === 'object') {
      return property;
    }
  }

  return undefined;
}
